/**
 * This file contains the configuration and initialization of the AngularJS app.
 * It defines the modules, constants, providers, and configuration settings used by the app.
 * The file also includes the definition of the global colors array and exception handling logic.
 * Additionally, it configures the translation and localization settings for the app.
 */
(function () {
    "use strict";

    var app = angular.module("app", [
        "ui.router",
        "angular.filter",
        // "angulartics",
        // "angulartics.google.analytics",
        // "angulartics.google.tagmanager",
        "pascalprecht.translate",
        "tmh.dynamicLocale",
        "ui.bootstrap.pagination",
        // "angulartics.mixpanel",
        // "angulartics.intercom",
        "ngAnimate",
        "ngResource",
        "ngLocale",
        "cleave.js",
        "angularMoment",
        "ui.router.metatags",
        "angular-cache",
        "ngDialog",
        "oc.lazyLoad",
        "angular-loading-bar",
        "ngCookies",
        "LocalStorageModule",
        "angular.bind.notifier",
        "app.resources",
        "app.newresources",
        "app.locale",
        "app.core",
        "app.shell",
        "app.common",
        "app.security"
    ]);

    app.constant("LOCALES", {
        locales: {
            "tr": "Türkçe",
            "en": "English",
            "es-ES": "Español",
            "pt-PT": "Português"
        },
        preferredLocale: "en",
    });

    app.config([
        "$httpProvider",
        "$anchorScrollProvider",
        "$qProvider",
        "$locationProvider",
        "$logProvider",
        "$compileProvider",
        "UIRouterMetatagsProvider",
        // "$analyticsProvider",
        "$urlMatcherFactoryProvider",
        "$sceDelegateProvider",
        "$provide",
        "$translateProvider",
        "$translatePartialLoaderProvider",
        "tmhDynamicLocaleProvider",
        "cfpLoadingBarProvider",
        "$ocLazyLoadProvider",
        // "DoubleClickProvider",
        "CacheFactoryProvider",
        "$animateProvider",
        function (
            $httpProvider,
            $anchorScrollProvider,
            $qProvider,
            $locationProvider,
            $logProvider,
            $compileProvider,
            UIRouterMetatagsProvider,
            // $analyticsProvider,
            $urlMatcherFactoryProvider,
            $sceDelegateProvider,
            $provide,
            $translateProvider,
            $translatePartialLoaderProvider,
            tmhDynamicLocaleProvider,
            cfpLoadingBarProvider,
            $ocLazyLoadProvider,
            // DoubleClickProvider,
            CacheFactoryProvider,
            $animateProvider
        ) {
            $httpProvider.interceptors.push('secureHttpInterceptor');


            window.globalColors = [
                // "#798897", // light grey
                // "#FF0550", // red
                // "#0087E1", // blue
                // "#009C00",
                // "#FF5897", // yellow
                // "#574141", // dark gray
                // "#98A4AE", // grey
                // "#FD2000", // tomato
                // "#54BAC1", // steel blue
                // "#006B72", // dark blue
                // "#E29898", // dark magenta
                // "#BFA5A5", // gray
                // "#0087A0", // green
                // "#688D00",
                '#FF0550', // Brand Red - Primary brand color
                '#58B1FF', // Brand Blue - Secondary brand color
                '#4CAF50', // Success Green - Modern vibrant green
                '#FF9800', // Warm Orange - Complementary to blue
                '#9C27B0', // Purple - Modern purple for variety
                '#00BCD4', // Cyan - Fresh and modern
                '#FF5722', // Deep Orange - Energetic and warm
                '#2196F3', // Bright Blue - Clean and professional
                '#8BC34A', // Light Green - Natural and fresh
                '#E91E63', // Pink - Vibrant and attention-grabbing
                '#795548', // Brown - Earthy and grounded
                '#607D8B', // Blue Grey - Professional and modern
                '#FFC107', // Amber - Warm and optimistic
                '#3F51B5', // Indigo - Deep and trustworthy
                '#FF6B35', // Coral Orange - Warm and inviting
                '#26A69A', // Teal - Balanced and calming
                '#AB47BC', // Medium Purple - Sophisticated
                '#42A5F5', // Sky Blue - Fresh and open
                '#66BB6A', // Forest Green - Natural and stable
                '#FFA726', // Orange - Energetic and friendly
                '#EC407A', // Rose Pink - Soft and appealing
                '#5C6BC0', // Slate Blue - Professional and modern
                '#78909C', // Cool Grey - Neutral and balanced
                '#FFB300', // Golden Yellow - Bright and optimistic
                '#8D6E63', // Warm Brown - Earthy and reliable
                '#00ACC1', // Turquoise - Fresh and modern
                '#7E57C2', // Deep Purple - Rich and elegant
                '#29B6F6', // Light Blue - Clean and trustworthy
                '#9CCC65', // Lime Green - Vibrant and natural
                '#FF7043', // Burnt Orange - Warm and energetic
                '#F06292', // Soft Pink - Gentle and approachable
                '#5E35B1', // Purple Blue - Deep and sophisticated
                '#90A4AE', // Silver Grey - Modern and neutral
                '#FFCA28', // Bright Yellow - Cheerful and attention-grabbing
                '#A1887F', // Taupe - Sophisticated and warm
                '#4DB6AC', // Mint Teal - Fresh and calming
                '#9575CD', // Lavender - Soft and elegant
                '#64B5F6', // Powder Blue - Light and airy
                '#AED581', // Pale Green - Soft and natural
                '#FFB74D', // Peach - Warm and friendly
                '#F8BBD9', // Blush Pink - Delicate and soft
                '#7986CB', // Periwinkle - Calm and trustworthy
                '#B0BEC5', // Light Grey - Neutral and clean
                '#FFF176', // Pale Yellow - Bright and cheerful
                '#BCAAA4', // Mushroom - Earthy and subtle
                '#80CBC4', // Seafoam - Fresh and soothing
                '#BA68C8', // Orchid - Vibrant and elegant
                '#81C784', // Mint Green - Fresh and balanced
                '#FFAB91', // Salmon - Warm and inviting
                '#CE93D8' // Lilac - Soft and sophisticated
            ];

            // window.onerror = function (message, url, line, column, error) {
            //     console.error(message, url, line, column, error);
            // };
            $provide.decorator("$exceptionHandler", [
                "$delegate",
                "$window",
                function ($delegate, $window) {
                    return function (exception, cause) {
                        if (typeof $window.TrackJS !== "undefined")
                            $window.TrackJS && $window.TrackJS.track(exception);

                        // $window.gtag('event', 'exception', {
                        //     'description': exception,
                        //     'fatal': false
                        // });

                        // console.log(exception);
                        // window.dataLayer.push({
                        //     event: "exception",
                        //     exception: {
                        //         'description': exception,
                        //         'fatal': false
                        //     }
                        // });

                        // In *non-production* environments you may still want the error sent to the console.
                        // You can delegate to the original handler (console.error) if you would like.
                        // Warning, this can cause double tracking of errors, so do not use in production.
                        if ($window.location.host !== "www.endeksa.com")
                            $delegate(exception, cause);
                    };
                },
            ]);

            angular.extend(CacheFactoryProvider.defaults, {
                maxAge: 15 * 60 * 1000,
                cacheFlushInterval: 15 * 60 * 1000,
                deleteOnExpire: 'aggresive'
            });


            $httpProvider.useApplyAsync(true);
            $compileProvider.aHrefSanitizationWhitelist(
                /^\s*(https?|ftp|mailto|tel|javascript|http?):/
            );
            // $compileProvider.preAssignBindingsEnabled(true);
            //$compileProvider.strictComponentBindingsEnabled(true);

            // spiner provieder
            cfpLoadingBarProvider.includeSpinner = false;
            cfpLoadingBarProvider.includeBar = true;
            cfpLoadingBarProvider.latencyThreshold = 200;

            // $analyticsProvider.virtualPageviews(false);
            // $analyticsProvider.trackStates(false);
            // $analyticsProvider.trackRoutes(false);
            // $analyticsProvider.firstPageview(false);
            // $analyticsProvider.withAutoBase(false);

            $anchorScrollProvider.disableAutoScrolling();

            $qProvider.errorOnUnhandledRejections(false);

            $urlMatcherFactoryProvider.strictMode(false);
            $urlMatcherFactoryProvider.caseInsensitive(true);
            // $urlMatcherFactoryProvider.defaultSquashPolicy('nosquash');

            // DoubleClickProvider.defineSlot('/21155722/endeksa_web/endeksa_w_anasayfa', [[728, 90], [970, 90], 'fluid'], 'div-gpt-ad-1646319323246-0')
            //     .defineSlot('/21155722/endeksa_web/endeksa_m_anasayfa', [[320, 100], 'fluid'], 'div-gpt-ad-1646319558735-0')
            //     .defineSlot('/21155722/endeksa_web/endeksa_w_blog_anasayfa', ['fluid', [728, 90], [970, 90]], 'div-gpt-ad-1646319280660-0')
            //     .defineSlot('/21155722/endeksa_web/endeksa_m_blog_anasayfa', ['fluid', [320, 100]], 'div-gpt-ad-1646319514606-0')
            //     .defineSlot('/21155722/endeksa_web/endeksa_w_blog_detay', [[728, 90], 'fluid'], 'div-gpt-ad-1646319230642-0')
            //     .defineSlot('/21155722/endeksa_web/endeksa_m_blog_haberdetay', ['fluid', [320, 100]], 'div-gpt-ad-1646319467089-0')
            //     .defineSlot('/21155722/endeksa_web/endeksa_w_edo', [[300, 250], 'fluid'], 'div-gpt-ad-1646319178221-0')
            //     .defineSlot('/21155722/endeksa_web/endeksa_m_edo', [[320, 100], 'fluid'], 'div-gpt-ad-1646319412113-0')
            //     .defineSlot('/21155722/endeksa_web/endeksa_w_kdh', [[300, 250], 'fluid'], 'div-gpt-ad-1646319094131-0')
            //     .defineSlot('/21155722/endeksa_web/endeksa_m_kdh', ['fluid', [300, 250]], 'div-gpt-ad-1646319372037-0');

            // set languageKey
            var urlPath = window.location.pathname;
            var urlPathString = urlPath.split("/");
            var keyLanguage = urlPathString[1] === "tr" ? "tr" : urlPathString[1] === "es-ES" ? "es-ES" : urlPathString[1] === "pt-PT" ? "pt-PT" : "en";

            // Set window.lang early for meta tag generation
            window.lang = keyLanguage;

            // try {
            //     var langDefined = window.localStorage.getItem("Language");
            //     if (!langDefined) {
            window.localStorage.setItem("Language", keyLanguage);
            window.localStorage.setItem("NG_TRANSLATE_LANG_KEY", keyLanguage);
            //     }
            //     else {
            //         keyLanguage = langDefined;
            //     }
            // }
            // catch (err) {
            //     //ignored
            //     console.log(err);
            // }


            // translations
            // Core translations are now merged into a single file to reduce HTTP requests
            // Previously loaded 7 separate files (url, fatFooter, navigation_top, register_user, authentication, content, cities)
            // Now loads 1 merged file: locale_core.json
            // The merged file is loaded as a 'part' called 'core' through the partial loader
            $translatePartialLoaderProvider.addPart('core');

            var urlLocal = "/assets/lang/{lang}/locale_{part}.json?v=" + window.appVersion;
            if (window.location.host === 'www.endeksa.com')
                urlLocal = "https://cdn.endeksa.com/lang/{lang}/locale_{part}.json?v=" + window.appVersion;
            else if (window.location.host === 'beta.endeksa.com')
                urlLocal = "https://beta-cdn.endeksa.com/lang/{lang}/locale_{part}.json?v=" + window.appVersion;
            else if (window.location.host === 'preprod.endeksa.com')
                urlLocal = "https://preprod-cdn.endeksa.com/lang/{lang}/locale_{part}.json?v=" + window.appVersion;
            // translation Logic
            // NOTE: Removed .useLocalStorage() to prevent loading all 4 languages unnecessarily
            // This reduces critical request chain by 600-800ms by only loading current language
            // Browser HTTP cache (Cache-Control: max-age=31536000) handles caching efficiently
            $translateProvider
                .useLoader("$translatePartialLoader", {
                    urlTemplate: urlLocal,
                })
                .preferredLanguage(keyLanguage)  // Use detected language from URL
                .fallbackLanguage('en')
                .useSanitizeValueStrategy("escape");


            var urlAngLocal = "/assets/locale/angular-locale_{{locale}}.js";
            if (window.location.host === 'www.endeksa.com')
                urlAngLocal = "https://cdn.endeksa.com/locale/angular-locale_{{locale}}.js";
            else if (window.location.host === 'beta.endeksa.com')
                urlAngLocal = "https://beta-cdn.endeksa.com/locale/angular-locale_{{locale}}.js";
            else if (window.location.host === 'preprod.endeksa.com')
                urlAngLocal = "https://preprod-cdn.endeksa.com/locale/angular-locale_{{locale}}.js";

            tmhDynamicLocaleProvider
                .localeLocationPattern(
                    urlAngLocal
                );

            //orderBy Turkish Character support
            // $provide.decorator("orderByFilter", [
            //     function () {
            //         var decoratedFilter = function (items, field, reverse) {
            //             var filtered = [];
            //             if (items && items.length)
            //                 items.forEach(function (item) {
            //                     filtered.push(item);
            //                 });
            //             filtered.sort(function (a, b) {
            //                 var aa =
            //                     typeof a[field] === "string" ?
            //                         a[field].toLocaleLowerCase() :
            //                         a[field];
            //                 var bb =
            //                     typeof b[field] === "string" ?
            //                         b[field].toLocaleLowerCase() :
            //                         b[field];
            //                 if (typeof aa === "string") return aa.localeCompare(bb);
            //                 else if (bb > aa) return (reverse ? -1 : 1);
            //                 else if (bb < aa) return (reverse ? 1 : -1);
            //                 else return 0;
            //             });
            //             return filtered;
            //         };
            //         return decoratedFilter;
            //     },
            // ]);

            //secure configuration for widget do not delete
            $sceDelegateProvider.resourceUrlWhitelist([
                // Allow same origin resource loads.
                "self",
                // Allow loading from our assets domain.  Notice the difference between * and **.
                "https://beta.endeksa.com/api/**",
                "https://**.endeksa.com/**",
                "http://localhost:6476/**",
                "http://localhost:8080/**",
                "http://localhost:8082/**",
                "https://endeksa-beta-storage.s3.eu-central-1.amazonaws.com/**",
                "https://endeksa-storage.s3.eu-central-1.amazonaws.com/**"
            ]);
            UIRouterMetatagsProvider.setTitleSuffix(" - Endeksa")
                .setDefaultTitle("Endeksa")
                .setDefaultRobots(
                    window.location.host === "www.endeksa.com" || window.location.host === "localhost:8080" ?
                        "index, follow" :
                        "noindex, nofollow"
                )
                .setStaticProperties({
                    "fb:app_id": "691540207677953",
                    "og:site_name": "Endeksa",
                })
                .setOGURL(true);


            // Set default meta description based on detected language
            if (keyLanguage === 'tr')
                UIRouterMetatagsProvider.setDefaultDescription(
                    "Gayrimenkulünüzün bulunduğu bölgede satış ve kira değerleri ne kadar? Kimler yaşıyor? Olanaklar neler? Tüm bu sorularınıza tek tık ile cevap alın!"
                );
            else if (keyLanguage === 'es-ES')
                UIRouterMetatagsProvider.setDefaultDescription(
                    "¿Cuáles son las ventas y alquileres en la región donde se ubica su propiedad? ¿Cuáles son las posibilidades? ¡Obtenga respuestas a todas estas preguntas!"
                );
            else if (keyLanguage === 'pt-PT')
                UIRouterMetatagsProvider.setDefaultDescription(
                    "Quais são as vendas e aluguéis na região onde seu imóvel está localizado? Quais são as possibilidades? Obtenha respostas para todas essas perguntas!"
                );
            else
                UIRouterMetatagsProvider.setDefaultDescription(
                    "What are the sales and rentals in the region your property located? What are the possibilities? Get answers to all these questions!"
                );



            // if (keyLanguage == 'tr')
            //     UIRouterMetatagsProvider.setDefaultKeywords(
            //         "endeksa, evimin değeri, evimin değeri ne kadar, nereye yatırım yapmalıyım, evimi nasıl değerlerim, konut endeksi, konut fiyatları, gayrimenkul değerleme, eksper, ekspertiz, gayrimenkul endeksi, rayiç, rayiç bedeller, fiyat trendi"
            //     );
            // else if (keyLanguage === 'es-ES')
            //     UIRouterMetatagsProvider.setDefaultKeywords(
            //         "endeksa, el valor de mi casa, cuanto vale mi casa, donde debo invertir, como valoro mi casa, indice de vivienda, precio de la vivienda, avalúo inmobiliario, avalúo, avalúo, índice inmobiliario, valores actuales de mercado, precio tendencia"
            //     );
            // else if (keyLanguage === 'pt-PT')
            //     UIRouterMetatagsProvider.setDefaultKeywords(
            //         "endeksa, o valor da minha casa, quanto vale a minha casa, onde devo investir, como valorizo minha casa, índice habitacional, preços das casas, avaliação imobiliária, avaliação, avaliação, índice imobiliário, valores atuais de mercado, preço tendência"
            //     );
            // else
            //     UIRouterMetatagsProvider.setDefaultKeywords(
            //         "endeksa, the value of my house, how much is my house worth, where should I invest, how do I value my house, housing index, house prices, real estate appraisal, appraisal, appraisal, real estate index, current market values, price trend"
            //     );



            $locationProvider.hashPrefix("");
            $locationProvider.html5Mode(true);
            $animateProvider.classNameFilter(/angular-animate|fade|menu/);
            $compileProvider.commentDirectivesEnabled(false);

            if (window.location.host !== 'www.endeksa.com' && window.location.host !== 'preprod.endeksa.com') {
                $logProvider.debugEnabled(true);
                $compileProvider.debugInfoEnabled(true);

                $ocLazyLoadProvider.config({
                    debug: false,
                    events: true
                });
            }
            else {
                $logProvider.debugEnabled(false);
                $compileProvider.debugInfoEnabled(false);
            }
        },
    ]);
    var CACHE = "";
    var NONCACHE = "";
    var NONPROXIED = "";
    var NEW = "";
    var NEWCACHE = "";
    var VALUATION = "";
    var REPORT = "";
    var HISTORY = "";
    function getEndpoints(env) {
        switch (env) {
            case 'prod':
                NEW = "https://apiv3.endeksa.com";
                NEWCACHE = "https://appv3.endeksa.com";
                CACHE = 'https://app.endeksa.com'; //beta new api without cache
                NONCACHE = 'https://api.endeksa.com'; //beta new api without cache
                NONPROXIED = "https://apinonproxied.endeksa.com";
                VALUATION = 'https://api-valuation.endeksa.com';
                REPORT = 'https://api-report.endeksa.com';
                HISTORY = 'https://apihistory.endeksa.com';
                break;
            case 'beta':
                NEW = "https://apiv3beta.endeksa.com";
                NEWCACHE = "https://apiv3beta.endeksa.com";
                CACHE = 'https://appbeta.endeksa.com'; //beta new api without cache
                NONCACHE = 'https://apibeta.endeksa.com'; //beta new api without cache
                NONPROXIED = "https://apibetanonproxied.endeksa.com";
                VALUATION = 'https://apibeta.endeksa.com';
                REPORT = 'https://apibeta.endeksa.com';
                HISTORY = 'https://apiv3beta.endeksa.com';
                break;
            case 'preprod':
                NEW = "https://apiv3-preprod.endeksa.com";
                NEWCACHE = "https://appv3.endeksa.com";
                CACHE = 'https://app-preprod.endeksa.com'; //beta new api without cache
                NONCACHE = 'https://api-preprod.endeksa.com'; //beta new api without cache
                NONPROXIED = "https://api-preprod.endeksa.com";
                VALUATION = 'https://api-preprod.endeksa.com';
                REPORT = 'https://api-preprod.endeksa.com';
                HISTORY = 'https://apihistory.endeksa.com';
                break;
            default:
                NEW = "https://apiv3.endeksa.com";
                NEWCACHE = "https://appv3.endeksa.com";
                CACHE = 'https://app.endeksa.com'; //beta new api without cache
                NONCACHE = 'https://api.endeksa.com'; //beta new api without cache
                NONPROXIED = "https://apinonproxied.endeksa.com";
                VALUATION = 'https://api-valuation.endeksa.com';
                REPORT = 'https://api-report.endeksa.com';
                HISTORY = 'https://apihistory.endeksa.com';
        }
    }

    function setAPIUrl() {
        if (location.host === "www.endeksa.com") {
            NEW = "https://apiv3.endeksa.com";
            NEWCACHE = "https://appv3.endeksa.com";
            CACHE = "https://app.endeksa.com";
            NONCACHE = "https://api.endeksa.com";
            NONPROXIED = "https://apinonproxied.endeksa.com";
            VALUATION = 'https://api-valuation.endeksa.com';
            REPORT = 'https://api-report.endeksa.com';
            HISTORY = 'https://apihistory.endeksa.com';
        } else if (location.host === "beta.endeksa.com") {
            NEW = "https://apiv3beta.endeksa.com";
            NEWCACHE = "https://apiv3beta.endeksa.com";
            CACHE = "https://appbeta.endeksa.com";
            NONCACHE = "https://apibeta.endeksa.com";
            NONPROXIED = "https://apibetanonproxied.endeksa.com";
            VALUATION = 'https://apibeta.endeksa.com';
            REPORT = 'https://apibeta.endeksa.com';
            HISTORY = 'https://apiv3beta.endeksa.com';
        } else if (location.host === "preprod.endeksa.com") {
            NEW = "https://apiv3-preprod.endeksa.com";
            NEWCACHE = "https://appv3.endeksa.com";
            CACHE = 'https://app-preprod.endeksa.com'; //beta new api without cache
            NONCACHE = 'https://api-preprod.endeksa.com'; //beta new api without cache
            NONPROXIED = "https://api-preprod.endeksa.com";
            VALUATION = 'https://api-preprod.endeksa.com';
            REPORT = 'https://api-preprod.endeksa.com';
            HISTORY = 'https://apihistory.endeksa.com';
        }
        else {
            getEndpoints('prod');
        }

        app.value("appSettingsSvc", {
            base: "",
            brand: "Endeksa",
            title: "Endeksa",
            siteUrl: "",
            NEW: NEW,
            CACHE: CACHE,
            NEWCACHE: NEWCACHE,
            NONCACHE: NONCACHE,
            NONPROXIED: NONPROXIED,
            VALUATION: VALUATION,
            REPORT: REPORT,
            HISTORY: HISTORY
        });
    }
    setAPIUrl();
    app.filter("to_trusted", [
        "$sce",
        function ($sce) {
            return function (text) {
                return $sce.trustAsHtml(text);
            };
        },
    ]);
    app.filter("maskName", function () {
        return function (text) {
            var splits = text.split(" ");
            var last = splits[splits.length - 1];
            last = last[0] + "."; //last.substring(1).replace(/./g, "*");
            var rest = [];
            for (var i = 0; i < splits.length - 1; i++) {
                rest.push(splits[i]);
            }

            return rest.join(" ") + " " + last;
        };
    });

    app.filter("ifEmpty", function () {
        return function (input, defaultValue) {
            if (
                angular.isUndefined(input) ||
                input === null ||
                input === "" ||
                input === "0%" ||
                input === "%0" ||
                +input === 0 ||
                input === "%0,00"
            ) {
                return defaultValue;
            }

            return input;
        };
    });

    app.filter("makePositive", function () {
        return function (num) {
            return Math.abs(num);
        };
    });

    app.factory("jQuery", [
        "window",
        function (window) {
            return window.jQuery;
        },
    ]);

    app.filter("strReplace", function () {
        return function (input, from, to) {
            input = input || "";
            from = from || "";
            to = to || "";
            return input.replace(new RegExp(from, "g"), to);
        };
    });

    app.filter("numKeys", function () {
        return function (json) {
            if (!json) return 0;
            var keys = Object.keys(json);
            return keys.length;
        };
    });
    app.directive("tooltip", function () {
        return {
            restrict: "A",
            link: function (scope, element, attrs) {
                if (attrs.trigger === 'click')
                    element.on('click',
                        function () {
                            element.tooltip("show");
                            setTimeout(function () { element.tooltip("hide"); }, 3000);
                        });
                else if (attrs.trigger === 'toggle')
                    element.on('click',
                        function () {
                            element.tooltip("toggle");
                        });
                else
                    element.hover(
                        function () {
                            // on mouseenter
                            element.tooltip("show");
                        },
                        function () {
                            // on mouseleave
                            element.tooltip("hide");
                        }
                    );
            },
        };
    });

    app.filter("capitalCase", function () {
        return function (text) {
            return text ? text.toUpperCase() : text;
        };
    });

    app.directive('crNumeric', ["$ocLazyLoad", function ($ocLazyLoad) {
        'use strict';
        // Declare a empty options object
        var options = {};
        return {
            // Require ng-model in the element attribute for watching changes.
            require: '?ngModel',
            // This directive only works when used in element's attribute (e.g: cr-numeric)
            restrict: 'A',
            compile: function (tElm, tAttrs) {
                var isTextInput = tElm.is('input:text');
                return function (scope, elm, attrs, controller) {
                    $ocLazyLoad.load('/assets/js/autonumeric.min.js').then(function () {
                        // Get instance-specific options.
                        var opts = angular.extend({}, options, scope.$eval(attrs.crNumeric));

                        // Helper method to update autoNumeric with new value.
                        var updateElement = function (element, newVal) {
                            // Only set value if value is numeric
                            if ($.isNumeric(newVal))
                                numericEl.set(newVal);
                            else if (angular.isUndefined(newVal) || newVal === null) {
                                numericEl.set('');
                            }
                        };

                        // Initialize element as autoNumeric with options.
                        // Bind to the linked element itself (not by id) and guard against
                        // re-init: stacked lazy-load callbacks after ng-if re-creations
                        // would otherwise attach duplicate keystroke handlers.
                        var numericEl = AutoNumeric.getAutoNumericElement(elm[0]) || new AutoNumeric(elm[0], opts);

                        // if element has controller, wire it (only for <input type="text" />)
                        if (controller && isTextInput) {
                            // render element as autoNumeric
                            controller.$render = function () {
                                updateElement(elm, controller.$viewValue);
                            };
                            elm.on('input', function (e) {
                                // if (e.which === 13) {
                                scope.$apply(function () {
                                    controller.$setViewValue(numericEl.get());
                                });
                                // }
                            });
                            elm.on('keydown', function (e) {
                                // if (e.which === 13) {
                                scope.$apply(function () {
                                    controller.$setViewValue(numericEl.get());
                                });
                                // }
                            });
                            // Detect changes on element and update model.
                            elm.on('change', function (e) {
                                scope.$apply(function () {
                                    controller.$setViewValue(numericEl.get());
                                });
                            });
                        }
                        else {
                            // Listen for changes to value changes and re-render element.
                            // Useful when binding to a readonly input field.
                            if (isTextInput) {
                                attrs.$observe('value', function (val) {
                                    updateElement(elm, val);
                                });
                            }
                        }
                    });
                };
            } // compile
        }; // return
    }]);

    app.directive("showDuringResolve", [
        "$transitions",
        "$timeout",
        "$window",
        "$rootScope",
        function ($transitions, $timeout, $window, $rootScope) {
            return {
                link: function (scope, element) {
                    element.addClass("ng-hide");
                    $rootScope.showTopSearch = false;
                    $rootScope.indexTarget = true;
                    $rootScope.mapTarget = false;
                    $rootScope.ad = 0;

                    // var resolver = $('<div class="white-overlay"></div><div class="loader-inner"><div class="loader-line-wrap"><div class="loader-line"></div></div><div class="loader-line-wrap"><div class="loader-line"></div></div><div class="loader-line-wrap"><div class="loader-line"></div></div><span class="loading-endeksa-red"></span></div>');

                    $transitions.onCreate({}, function () {
                        // if (!element.find('.white-overlay').length) {
                        // element.append(resolver);

                        // if (!$rootScope.layoutInitiated)
                        element.removeClass("ng-hide");
                        // }
                        if (!$window.barLoaded)
                            $rootScope.hideBar = true;
                        $window.prerenderReady = false;
                    });

                    $transitions.onSuccess({}, function (transition) {
                        element.addClass("ng-hide");
                        $rootScope.hideBar = false;
                        $window.barLoaded = true;

                        //waiting for data causes long rendering times and causes prerender to timeout
                        // if (transition.to().name.indexOf('.value') === -1 &&
                        //     transition.to().name.indexOf('.demographics') === -1 &&
                        //     transition.to().name.indexOf('.agents') === -1 &&
                        //     transition.to().name.indexOf('.election') === -1 &&
                        //     transition.to().name.indexOf('.opportunity') === -1 &&
                        //     transition.to().name.indexOf('.projects') === -1 &&
                        //     transition.to().name.indexOf('.malls') === -1)
                        $timeout(function () {
                            $window.prerenderReady = true;
                        });
                    });

                    $transitions.onError({}, function (transition) {
                        var rejection = transition.error();
                        if (rejection.type === 5) {
                            element.addClass("ng-hide");
                            $rootScope.hideBar = false;
                            $window.barLoaded = true;
                            $timeout(function () {
                                $window.prerenderReady = true;
                            });
                        }
                    });
                }
            };
        },
    ]);

    app.directive("ngEnter", function () {
        return function (scope, element, attrs) {
            element.bind("keydown keypress", function (event) {
                if (event.which === 13) {
                    scope.$apply(function () {
                        scope.$eval(attrs.ngEnter);
                    });
                    event.preventDefault();
                }
            });
        };
    });

    app.directive("ngFocusOut", function () {
        return function (scope, element, attrs) {
            element.bind("focusout", function (event) {
                scope.$apply(function () {
                    scope.$eval(attrs.ngFocusOut);
                });
                event.preventDefault();
            });
        };
    });

    app.directive("ngTypeEnds", ["$timeout", function ($timeout) {
        return function (scope, element, attrs) {
            //setup before functions
            var typingTimer;                //
            element.bind("keyup", function (event) {
                if (typingTimer)
                    $timeout.cancel(typingTimer);
                if (angular.element(element)[0].value) {
                    typingTimer = $timeout(function () {
                        scope.$apply(function () {
                            scope.$eval(attrs.ngTypeEnds);
                        });
                    }, 500);
                }

                event.preventDefault();
            });
        };
    }]);


    app.directive('jsonld', ['$filter', '$sce', function ($filter, $sce) {
        return {
            restrict: 'E',
            template: function () {
                return '<script type="application/ld+json" ng-bind-html="onGetJson()"></script>';
            },
            scope: {
                json: '=json'
            },
            link: function (scope, element, attrs) {
                scope.onGetJson = function () {
                    return $sce.trustAsHtml($filter('json')(scope.json));
                };
            },
            replace: true
        };
    }]);

    app.filter("emptyToEnd", function () {
        return function (array, key) {
            if (!angular.isArray(array)) return;
            var present = array.filter(function (item) {
                return item[key];
            });
            var empty = array.filter(function (item) {
                return !item[key];
            });
            return present.concat(empty);
        };
    });


    app.directive("lazyVideo", [
        "$window",
        function ($window) {
            return {
                restrict: "A",
                scope: {
                    lazy: "@lazy",
                },
                link: function (scope, element, attrs) {
                    function isScrolledIntoView(el) {
                        try {
                            var rect = el.getBoundingClientRect();
                            var elemTop = rect.top;
                            var elemBottom = rect.bottom;
                            var isVisible = elemTop >= 0 && elemBottom <= $window.innerHeight;
                            return isVisible;
                        }
                        catch (err) {
                            return false;
                        }
                    }
                    var promise;

                    function onVisibilityChange() {
                        var el = angular.element(element);
                        if (!el.length)
                            return false;

                        var visible = isScrolledIntoView(el[0]);
                        if (visible && !promise) {
                            var source = el.find('source');
                            source[0].src = source.attr('lazy').trim();
                            el[0].load();
                            promise = el[0].play();
                        }
                        else if (visible && promise) {
                            promise = el[0].play();
                        }
                        else {
                            if (promise) {
                                promise.then(function () {
                                    el[0].pause();
                                });
                            } else el[0].pause();
                        }
                    }
                    angular
                        .element($window)
                        .bind("DOMContentLoaded load resize scroll", onVisibilityChange);
                    var cleanUp = function () {
                        angular.element($window).unbind('DOMContentLoaded load resize scroll', onVisibilityChange);
                    };
                    scope.$on('$destroy', cleanUp);
                },
            };
        },
    ]);

    app.directive('errSrc', function () {
        return {
            link: function (scope, element, attrs) {
                element.bind('error', function () {
                    if (attrs.src != attrs.errSrc) {
                        if (attrs.errSrc)
                            attrs.$set('src', attrs.errSrc);
                    }
                });
            }
        };
    });

    // Check browser support for modern image formats (cached)
    var supportsAVIF = null;
    var supportsWebP = null;

    function checkAVIFSupport(callback) {
        if (supportsAVIF !== null) return callback(supportsAVIF);

        var avif = new Image();
        avif.onload = function () {
            supportsAVIF = (avif.width > 0 && avif.height > 0);
            callback(supportsAVIF);
        };
        avif.onerror = function () {
            supportsAVIF = false;
            callback(supportsAVIF);
        };
        avif.src = 'data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAAB0AAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAIAAAACAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQ0MAAAAABNjb2xybmNseAACAAIAAYAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAACVtZGF0EgAKCBgANogQEAwgMg8f8D///8WfhwB8+ErK42A=';
    }

    function checkWebPSupport(callback) {
        if (supportsWebP !== null) return callback(supportsWebP);

        var webp = new Image();
        webp.onload = function () {
            supportsWebP = (webp.width > 0 && webp.height > 0);
            callback(supportsWebP);
        };
        webp.onerror = function () {
            supportsWebP = false;
            callback(supportsWebP);
        };
        webp.src = 'data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACyAgCdASoCAAIALmk0mk0iIiIiIgBoSygABc6WWgAA/veff/0PP8bA//LwYAAA';
    }

    app.directive("lazyLoad", function () {
        return {
            restrict: "A",
            scope: {
                lazy: "@lazy",
            },
            link: function (scope, element, attrs) {
                if (IntersectionObserver) {
                    var observer = new IntersectionObserver(loadImg);
                    var img = angular.element(element)[0];
                    observer.observe(img);
                } else if (attrs.lazy) {
                    // Fallback for old browsers - load original
                    element.src = attrs.lazy.trim();
                    $(element).addClass("img-loaded");
                }

                function loadImg(changes) {
                    changes.forEach(function (change) {
                        if (change.intersectionRatio > 0 && attrs.lazy) {
                            var originalSrc = attrs.lazy.trim();

                            // Load original source directly (AVIF, WebP, JPG, PNG, SVG, GIF - whatever is specified)
                            change.target.src = originalSrc;
                            change.target.onload = function () {
                                change.target.classList.add("img-loaded");
                                observer.unobserve(change.target);
                            };

                            /* PREVIOUS APPROACH - COMMENTED OUT - Auto format detection
                            // Get base path without extension
                            var basePath = originalSrc.replace(/\.(jpg|jpeg|png|webp|avif)$/i, '');

                            // Check if it's a raster image that can have multiple formats
                            if (originalSrc.match(/\.(jpg|jpeg|png|webp)$/i)) {
                                // Try modern formats in order: AVIF → WebP → Original (JPG/PNG)
                                // Even if original is .avif, try AVIF first!
                                checkAVIFSupport(function (hasAVIF) {
                                    if (hasAVIF) {
                                        var avifSrc = basePath + '.avif';
                                        var testImg = new Image();
                                        testImg.onload = function () {
                                            change.target.src = avifSrc;
                                            change.target.onload = function () {
                                                change.target.classList.add("img-loaded");
                                                observer.unobserve(change.target);
                                            };
                                        };
                                        testImg.onerror = function () {
                                            tryWebP();
                                        };
                                        testImg.src = avifSrc;
                                    } else {
                                        tryWebP();
                                    }
                                });

                                function tryWebP() {
                                    // If original was already WebP, use it
                                    if (originalSrc.match(/\.avif$/i)) {
                                        loadOriginal();
                                        return;
                                    }

                                    checkWebPSupport(function (hasWebP) {
                                        if (hasWebP) {
                                            var webpSrc = basePath + '.avif';
                                            var testImg = new Image();
                                            testImg.onload = function () {
                                                change.target.src = webpSrc;
                                                change.target.onload = function () {
                                                    change.target.classList.add("img-loaded");
                                                    observer.unobserve(change.target);
                                                };
                                            };
                                            testImg.onerror = function () {
                                                // WebP not available, use original
                                                loadOriginal();
                                            };
                                            testImg.src = webpSrc;
                                        } else {
                                            loadOriginal();
                                        }
                                    });
                                }

                                function loadOriginal() {
                                    change.target.src = originalSrc;
                                    change.target.onload = function () {
                                        change.target.classList.add("img-loaded");
                                        observer.unobserve(change.target);
                                    };
                                }
                            } else {
                                // SVG, GIF, or already AVIF - load as-is
                                change.target.src = originalSrc;
                                change.target.onload = function () {
                                    change.target.classList.add("img-loaded");
                                    observer.unobserve(change.target);
                                };
                            }
                            */
                        }
                    });
                }
            },
        };
    });
    app.directive('trendLoading', [function () {
        return {
            restrict: 'EA',
            templateUrl: '/app/bolgesel-analiz/views/trend-loading.html',
            scope: {
                trendNo: '<'
            },
            link: function (scope) {
                scope.trendNo = Math.floor(Math.random() * 100);

                var selected = [
                    "ei-units",
                    "ei-hand-change",
                    "ei-calendar-time",
                    "ei-check"
                ];
                setTimeout(function () {
                    $('#barRatingLoad' + scope.trendNo).barrating({
                        theme: 'bars-pill',
                        readonly: true,
                        initialRating: 1
                    });
                    $('#barRatingLoad' + scope.trendNo).barrating('set', 1);
                });
                var interv = setInterval(function () {
                    $('#barRatingLoad' + scope.trendNo).barrating('set', window.loadingBarRating + 1);

                    $('#rotatingIcon' + scope.trendNo).attr('class', selected[window.loadingBarRating - 1]);

                    if (window.loadingBarRating > 4)
                        clearInterval(interv);
                }, 100);
            }
        };
    }]);
    app.directive('rotateValuation', ['$interval', '$timeout', '$translate',
        function ($interval, $timeout, $translate) {
            return {
                restrict: 'EA',
                scope: {
                    rotateTrend: '<',
                },
                link: function (scope, element, attrs) {
                    // scope.wordArr = ['Yakın mesafedeki benzer emsaller bulunuyor', 'Geçmiş tarihli benzer emsaller bulunuyor', 'Alan genişletilerek emsaller bulunuyor', 'Zaman düzeltmesi yapılıyor', 'Standart sapmalar hesaplanıyor', 'Mahalle seviyesinde değere etki eden faktörler hesaplanıyor', 'İlçe seviyesinde değere etki eden faktörler hesaplanıyor', 'İl seviyesinde değere etki eden faktörler hesaplanıyor', 'Benzer bölgelerdeki değer değişimi hesaplanıyor', 'Neredeyse bitti. İşlem tamamlanıyor'];

                    scope.wordArr = [];
                    if (!scope.rotateTrend) {
                        scope.wordArr.push($translate.instant('valuation_loading1'));
                        scope.wordArr.push($translate.instant('valuation_loading2'));
                        scope.wordArr.push($translate.instant('valuation_loading3'));
                        scope.wordArr.push($translate.instant('valuation_loading4'));
                        scope.wordArr.push($translate.instant('valuation_loading5'));
                        scope.wordArr.push($translate.instant('valuation_loading6'));
                        scope.wordArr.push($translate.instant('valuation_loading7'));
                        scope.wordArr.push($translate.instant('valuation_loading8'));
                        scope.wordArr.push($translate.instant('valuation_loading9'));
                        scope.wordArr.push($translate.instant('valuation_loading10'));
                    } else {
                        scope.wordArr.push($translate.instant('trend_loading1'));
                        scope.wordArr.push($translate.instant('trend_loading2'));
                        scope.wordArr.push($translate.instant('trend_loading3'));
                        scope.wordArr.push($translate.instant('trend_loading4'));
                        scope.wordArr.push($translate.instant('valuation_loading10'));
                    }

                    scope.dots = ['', '.', '..', '...'];


                    function generateRandom(min = 3000, max = 10000) {

                        if (scope.rotateTrend) {
                            min = 2000;
                            max = 3000;
                        }

                        let difference = max - min;
                        let rand = Math.random();
                        rand = Math.floor(rand * difference);
                        rand = rand + min;
                        return rand;
                    }

                    var current = scope.wordArr[0], stopDot, stopWord, j = 0;
                    function updateWord() {
                        j++;

                        if (window.valuationCompleted && !scope.rotateTrend)
                            j = 9;
                        else if (window.valuationCompleted && scope.rotateTrend)
                            j = 4;

                        element.text(scope.wordArr[j]);
                        current = scope.wordArr[j];

                        window.loadingBarRating = j;
                        $interval.cancel(stopDot);
                        stopDot = $interval(updateDot, 500);

                        if (j !== scope.wordArr.length - 1)
                            stopWord = $timeout(updateWord, generateRandom());
                    }

                    function updateDot(i) {
                        var t = i % 4;
                        element.text(current + scope.dots[t]);
                        if (window.valuationCompleted)
                            updateWord();
                    }

                    window.valuationCompleted = false;
                    window.loadingBarRating = 0;
                    element.text(current + scope.dots[0]);
                    stopDot = $interval(updateDot, 500);
                    stopWord = $timeout(updateWord, generateRandom());
                    element.on('$destroy', function () {
                        $timeout.cancel(stopWord);
                        $interval.cancel(stopDot);
                    });
                }
            };
        }]);


    app.directive('selectpicker', ['$parse', '$timeout', function ($parse, $timeout) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                if (typeof $.fn.selectpicker === 'undefined') {
                    console.warn('selectpicker directive: bootstrap-select not loaded yet');
                    return;
                }

                $timeout(function () {
                    element.selectpicker($parse(attrs.selectpicker)());
                    // if (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent))
                    //     element.selectpicker('mobile');
                    // else
                    element.selectpicker();
                }, 0);

                scope.$watch(attrs.ngModel, function (newVal, oldVal) {
                    scope.$parent[attrs.ngModel] = newVal;

                    scope.$evalAsync(function () {
                        if (!attrs.ngOptions || /track by/.test(attrs.ngOptions))
                            element.val(newVal);
                        if (typeof $.fn.selectpicker !== 'undefined') {
                            element.selectpicker('refresh');
                        }
                    });
                });

                scope.$on('$destroy', function () {
                    scope.$evalAsync(function () {
                        if (typeof $.fn.selectpicker !== 'undefined') {
                            element.selectpicker('destroy');
                        }
                    });
                });
            }
        };
    }]);

    app.directive("lazyLoadTns", function () {
        return {
            restrict: "A",
            scope: {
                lazy: "@lazy",
            },
            link: function (scope, element, attrs) {
                if (IntersectionObserver) {
                    var observer = new IntersectionObserver(loadImg);
                    var img = angular.element(element)[0];
                    observer.observe(img);
                } else if (attrs.lazy) {
                    if ($(element).hasClass("loaded"))
                        element.src = attrs.lazy.trim();
                    else
                        element.setAttribute("data-src", attrs.lazy.trim());
                    $(element).addClass("img-loaded");
                }

                function loadImg(changes) {
                    changes.forEach(function (change) {

                        if (change.intersectionRatio > 0 && attrs.lazy) {
                            setTimeout(function () {
                                attrs.lazy = attrs.lazy || "/assets/img/empty_list.avif";
                                if ($(change.target).hasClass("loaded"))
                                    change.target.src = attrs.lazy.trim();
                                else
                                    change.target.setAttribute("data-src", attrs.lazy.trim());
                                change.target.onload = function () {
                                    change.target.classList.add("img-loaded");
                                };

                            }, 100);
                        }
                    });
                }
            },
        };
    });

    app.directive('formatNumber', function ($filter) {
        'use strict';

        return {
            require: '?ngModel',
            link: function (scope, elem, attrs, ctrl) {
                if (!ctrl) {
                    return;
                }

                ctrl.$formatters.unshift(function () {
                    return $filter('number')(ctrl.$modelValue);
                });

                ctrl.$parsers.unshift(function (viewValue) {
                    var plainNumber = viewValue.replace(/[\,\.]/g, ''),
                        b = $filter('number')(plainNumber);

                    elem.val(b === '0' ? '' : b);

                    return plainNumber;
                });
            }
        };
    });

    // Custom cached partial loader - caches ALL translations after first load
    // Prevents duplicate CDN requests for the same translation files
    // angular.module('app')
    //     .factory('cachedPartialLoader', ['$http', '$q', '$translatePartialLoader', function ($http, $q, $translatePartialLoader) {
    //         // Cache for loaded translation data: cache[lang][part] = data
    //         var translationCache = {};
    //         // Cache for in-flight requests: promiseCache[lang][part] = promise
    //         var promiseCache = {};

    //         return function (options) {
    //             var lang = options.key;
    //             var parts = $translatePartialLoader.getRegisteredParts();

    //             // Initialize caches for this language if needed
    //             if (!translationCache[lang]) {
    //                 translationCache[lang] = {};
    //             }
    //             if (!promiseCache[lang]) {
    //                 promiseCache[lang] = {};
    //             }

    //             // Collect all parts that need to be loaded
    //             var partsToLoad = [];
    //             var cachedTranslations = {};
    //             var waitingPromises = [];

    //             // Check which parts are already cached or being loaded
    //             parts.forEach(function (part) {
    //                 if (translationCache[lang][part]) {
    //                     // Use cached version
    //                     angular.extend(cachedTranslations, translationCache[lang][part]);
    //                 } else if (promiseCache[lang][part]) {
    //                     // Already loading, wait for the existing promise
    //                     waitingPromises.push(
    //                         promiseCache[lang][part].then(function (data) {
    //                             return { part: part, data: data };
    //                         })
    //                     );
    //                 } else {
    //                     // Need to load from CDN
    //                     partsToLoad.push(part);
    //                 }
    //             });

    //             // If all parts are cached or being loaded, wait and return
    //             if (partsToLoad.length === 0) {
    //                 if (waitingPromises.length > 0) {
    //                     return $q.all(waitingPromises).then(function (results) {
    //                         results.forEach(function (result) {
    //                             angular.extend(cachedTranslations, result.data);
    //                         });
    //                         return cachedTranslations;
    //                     });
    //                 } else {
    //                     return $q.resolve(cachedTranslations);
    //                 }
    //             }

    //             // Build URL template based on environment
    //             var urlTemplate = "/assets/lang/{lang}/locale_{part}.json?v=" + window.appVersion;
    //             if (window.location.host === 'www.endeksa.com')
    //                 urlTemplate = "https://cdn.endeksa.com/lang/{lang}/locale_{part}.json?v=" + window.appVersion;
    //             else if (window.location.host === 'beta.endeksa.com')
    //                 urlTemplate = "https://beta-cdn.endeksa.com/lang/{lang}/locale_{part}.json?v=" + window.appVersion;
    //             else if (window.location.host === 'preprod.endeksa.com')
    //                 urlTemplate = "https://preprod-cdn.endeksa.com/lang/{lang}/locale_{part}.json?v=" + window.appVersion;

    //             // Load all uncached parts and cache the promises
    //             partsToLoad.forEach(function (part) {
    //                 var url = urlTemplate.replace('{lang}', lang).replace('{part}', part);

    //                 // Create and cache the promise
    //                 var promise = $http.get(url).then(function (response) {
    //                     // Cache the data
    //                     translationCache[lang][part] = response.data;
    //                     // Clear the promise from cache
    //                     delete promiseCache[lang][part];
    //                     return response.data;
    //                 }).catch(function (error) {
    //                     console.error('Failed to load translation part: ' + lang + '/' + part, error);
    //                     // Clear the promise from cache on error
    //                     delete promiseCache[lang][part];
    //                     return {};
    //                 });

    //                 // Cache the promise so other concurrent calls can wait for it
    //                 promiseCache[lang][part] = promise;
    //                 waitingPromises.push(promise.then(function (data) {
    //                     return { part: part, data: data };
    //                 }));
    //             });

    //             // Wait for all requests (new + in-flight) to complete
    //             return $q.all(waitingPromises).then(function (results) {
    //                 var allTranslations = angular.copy(cachedTranslations);
    //                 results.forEach(function (result) {
    //                     angular.extend(allTranslations, result.data);
    //                 });
    //                 return allTranslations;
    //             });
    //         };
    //     }])
    //     .config(['$translateProvider', function ($translateProvider) {
    //         // Use custom cached loader instead of default partial loader
    //         $translateProvider.useLoader('cachedPartialLoader');
    //     }]);
})();
